import { SelectionChangedEvent } from "ag-grid-community";
import { ChargeConstant } from "presentation/constant/ChargeHeader/ChargeConstant";
import { INITIAL_CHARGE_HEADER_COL_DEF, transferShipboundedRowData } from "presentation/constant/ChargeHeader/ChargeHeaderContainerColumnDefinition";
import { useChargeHeaderMaintenanceVM } from "presentation/hook/ChargeHeaderMaintenance/useChargeHeaderMaintenanceVM";
import { useChargeHeaderMaintenanceTracked } from "presentation/store/ChargeHeaderMaintenance/ChargeHeaderMaintenanceProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { Suspense, memo, useCallback, useEffect, useMemo, useRef, useState } from "react";

const ChargeHeaderSearchTablePanel = () => {
    const [chargeHeaderSearchState] = useChargeHeaderMaintenanceTracked();
    const searchCriteria = chargeHeaderSearchState.searchCriteria;
    const chargeHeaderMainVM = useChargeHeaderMaintenanceVM();
    let gridRef: any = useRef();
    const tableId = "chargeHeaderTable"
    const { hdrGroupName } = searchCriteria;
    const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);
    const [showOverlay, setShowOverlay] = useState<boolean>(true);

    useEffect(() => {
        if (!chargeHeaderSearchState.selectedChargeHeaderRows ||
            chargeHeaderSearchState.selectedChargeHeaderRows.length <= 0) {
            //gridRef.current?.gridRef.current.api?.setColumnDefs(getCurrentTableColumnDefs());
            if (!onTableSelectionClicked) {
                gridRef.current?.gridRef.current.api?.deselectAll();
            }
        }
    }, [chargeHeaderSearchState.selectedChargeHeaderRows, onTableSelectionClicked, searchCriteria.hdrGroupName])

    useEffect(() => {
        if (onTableSelectionClicked) return;

        gridRef.current?.gridRef.current.api?.deselectAll();

    }, [onTableSelectionClicked])

    useEffect(() => {
        if (!chargeHeaderSearchState.isShowCriteriaPanel) {
            chargeHeaderMainVM.openSearchCriteriaPanel();
        }
    })

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        setOnTableSelectionClicked(true);

        const selectedRows = e.api.getSelectedRows();
        chargeHeaderMainVM.updateSelectedChargeHeaders(selectedRows);
    }, [chargeHeaderMainVM])

    useEffect(() => {
        setShowOverlay(chargeHeaderSearchState.isSearchLoading || (!chargeHeaderSearchState.isSearchLoading &&
            chargeHeaderSearchState.chargeHeaderEntities && chargeHeaderSearchState.chargeHeaderEntities.length) ? false : true);

        if (gridRef.current?.gridRef.current &&
            !chargeHeaderSearchState.isSearchLoading &&
            gridRef.current?.gridRef.current?.api?.getSelectedNodes()?.length > 0) {
            gridRef.current?.gridRef.current?.api?.getSelectedNodes()?.forEach((node: any) => {
                node.setSelected(false);
            });
        }
    }, [chargeHeaderSearchState.chargeHeaderEntities, chargeHeaderSearchState.isSearchLoading]);

    const memoTable = useMemo(() => {
        return <NbisTable
            id={tableId + hdrGroupName}
            key={tableId + hdrGroupName}
            isNewColumnSetting={true}
            columns={INITIAL_CHARGE_HEADER_COL_DEF}
            headerLabel={"VESSEL" === searchCriteria?.hdrGroupName ? ChargeConstant.ChargeHeader.VESSEL : ChargeConstant.ChargeHeader.OPS_DATE}
            data={transferShipboundedRowData(chargeHeaderSearchState.chargeHeaderEntities ?? [])}
            showPaginator={false}
            editable={false}
            showAddIcon={false}
            showDeleteButton={false}
            showReloadIcon={false}
            showUploadIcon={true}
            isScrollHighlighted={true}
            selectionMode={false}
            handleSelectionChanged={handleSelectionChange}
            rowSelection={"multiple"}
            isRowHighligted={true}
            suppressRowClickSelection={false}
            gridHeight="customHeight"
            customHeight="calc(100vh - 125px)"
            ref={gridRef}
            onRowDoubleClick={(e: any) => { chargeHeaderMainVM.goToChargeDetail(e.data) }}
            showDefaultOverlayNoRowsTemplate={showOverlay}
        />
    }, [hdrGroupName, searchCriteria?.hdrGroupName, chargeHeaderSearchState.chargeHeaderEntities, handleSelectionChange, showOverlay, chargeHeaderMainVM]);


    return <Suspense>
        {memoTable}
    </Suspense>



}

export default memo(ChargeHeaderSearchTablePanel);